import React from 'react';
import { Circular } from 'styled-loaders-react';
import Background from '../elements/background';
var LoaderWrapper = function () { return (React.createElement(Background, { color: 'primary' },
    React.createElement(Circular, { color: 'white' }))); };
export default LoaderWrapper;
